import { NavLink, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import DashboardLayout from "@/layouts/dashboard-layout";
import PatnersCard from "./partners-card";
import "./styles.scss";
import { ScheduleCard } from "@/components/ScheduleCard";
import ReactCalendar, {
  type CalendarProps as BaseCalendarProps,
} from "react-calendar";
import styles from "./calendar.module.scss";
import "../../App.css";
import Icon from "../../components/Icon";
import { endOfWeek, startOfWeek } from "date-fns";
import { Button, Calendar } from "@/components";
import {
  convertDateTimeArray,
  formatStringtoDate,
  generateTimeSlots,
} from "@/utils/function";
import {
  useCreateItemMutation,
  useGetItemsQuery,
} from "@/services/apiSlice/utilitySlice";
import { toast } from "sonner";
import { skipToken } from "@reduxjs/toolkit/query";
import DropdownMenu from "@/components/Dropdown";
import user from "../../image/user2.png";

type ValuePiece = Date | null;
type Value = ValuePiece | [ValuePiece, ValuePiece];

interface dateTime {
  date: Value | null;
  time: string;
  partner: partnerDetails;
  comtools: string;
}

interface partnerDetails {
  name: string;
  rating: number;
  sessions: number;
  about: string;
  comtools: string[];
  id: number;
  firstName: string;
  lastName: string;
  profilePictureUrl: string;
  userId?: string;
}

interface langTaught {
  language: string;
  proficiency: string;
}

interface partnerType {
  firstName: string;
  lastName: string;
  id: string;
  profilePictureUrl: string;
  sessions?: string;
  rating?: string;
  about?: string;
  languagesTaught: { language: string; proficiency: string }[];
}

export default function Partners() {
  const [visible, setVisible] = useState<number>(0);
  const [viewProfile, setViewProfile] = useState<partnerType | null>();
  const [id, setId] = useState("");
  const [dayTime, updateDayTime] = useState<Date>(new Date());
  const [showTimeSlot, setShowTimeSlot] = useState(false);
  const [booking, setBooking] = useState<dateTime>({
    date: new Date(),
    time: "",
    partner: {} as partnerDetails,
    comtools: "",
  });
  const [pickedPartner, setPickedpartner] = useState("");
  const [dateSelected, setDateSelected] = useState<{ date: string; time: string }[]>([]);
  const [timeSelected, setTimeSelected] = useState<string>();

  const { data, isLoading, error } = useGetItemsQuery("/merchants/partners/");

  const partnerId = booking?.partner?.id;

  const { data: availableDay, isLoading: availableDayLoading } = useGetItemsQuery(
    partnerId ? `/merchants/partners/availability?partnerId=${partnerId}` : skipToken
  );

  const partners = data?.result?.partners;
  const [createItem, { isLoading: isSubmitting, error: isError }] = useCreateItemMutation();

  const handleSubmit = async () => {
    if (!booking.partner.id || !booking.date) {
      toast.warning("Something went wrong, try booking again!");
    } else {
      try {
        await createItem({
          url: "/bookings/partner-session",
          credentials: {
            merchantId: booking.partner.id,
            timeSlots: convertDateTimeArray(dateSelected),
          },
        }).unwrap();
        setVisible(5);
        toast.success("Session has been booked Successfully");
      } catch (err: any) {
        console.warn(err);

        toast.error((err?.data?.message as any) || "Something went wrong");
      }
    }
  };

  const checkdayTime = (value: Date | string): boolean => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return value < today;
  };
  const handleSelect = (value: string) => {
    onDateClick("time", value);
    setTimeSelected(value);
  };

  const onDateClick = (type: string, e: Date | string) => {
    const selectedDate = new Date(e).setHours(0, 0, 0, 0);

    const isPicked = availableDay?.result.some((item: any) => {
      let startofDay = new Date(item?.start).setHours(0, 0, 0, 0);
      return startofDay === selectedDate;
    });

    if (checkdayTime(e)) {
      toast.warning("You cannot select a past date. Please select a later date");
    } else {
      setDateSelected((prevDates) => {
        if (type === "day") {
          if (!isPicked) {
            toast.warning(`${pickedPartner} is not available today, please pick another day`, {
              richColors: true,
            });
          } else {
            updateDayTime(new Date(e));
            return prevDates;
          }
        }

        if (type === "time" && dayTime) {
          return [
            {
              date: dayTime.toISOString(),
              time: (e as Date).toLocaleString(),
            },
          ];
        }

        return prevDates;
      });

      setShowTimeSlot(type === "day");
    }
  };

  const handleProfile = (id: string) => {
    if (id !== undefined) {
      const partner = partners.find((item: partnerType, index: number) => item?.id === id);
      if (partner) {
        setViewProfile(partner);
        setVisible(6);
      }
    }
  };

  const addPartner = (id: string, e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();

    setPickedpartner(() => {
      let picked = partners.find((partner: partnerType) => {
        if (partner?.id === id) {
          return true;
        }
      });

      return `${picked?.firstName} ${picked?.lastName}`;
    });

    if (id !== undefined) {
      setId(id);
      const partner = partners.find((item: partnerType) => item.id === id);
      if (partner) {
        setBooking((prev) => ({ ...prev, partner: partner }));
      }
    }
  };

  return (
    <DashboardLayout>
      <div className="partner-schedule">
        <section>
          <PatnersCard setVisible={setVisible} />
        </section>
        <div className={styles.stepsbox}>
          {visible !== 0 && (
            <button
              className={styles.calClose}
              onClick={() => {
                if (visible !== 3) {
                  setVisible(visible - 1);
                  if (visible === 6) {
                    setVisible(1);
                  }
                } else {
                  setVisible(2);
                }
              }}
            >
              {visible === 1 ? (
                <>
                  {" "}
                  <Icon name="close" />
                  <p>Close</p>
                </>
              ) : (
                <>
                  <Icon name="left_arrow" />
                  <p>Back</p>
                </>
              )}
            </button>
          )}
          {visible === 1 ? (
            <div className={styles.box2}>
              <p>Select a partner</p>
              <div className={styles.pBox}>
                {partners?.map((item: partnerType, index: number) => (
                  <div
                    key={index}
                    className={id === item.id ? styles.selected : styles.partners}
                    typeof="button"
                    onClick={(e: React.MouseEvent<HTMLDivElement>) => addPartner(item?.id, e)}
                  >
                    {item?.profilePictureUrl ? (
                      <img alt="avatar" className={styles.avatar} src={item.profilePictureUrl} />
                    ) : (
                      <img alt="avatar" className={styles.avatar} src={user} />
                    )}
                    <div>
                      <h3>
                        {item.firstName} {item.lastName}
                      </h3>
                      <div className={styles.funcs}>
                        {item?.languagesTaught?.map((lang: langTaught, i: number) => (
                          <div key={i} className={styles.langTeach}>
                            <p>{lang?.language}</p>
                            <span>{lang.proficiency}</span>
                          </div>
                        ))}
                      </div>
                      <button className={styles.profil} onClick={() => handleProfile(item?.id)}>
                        view Profile
                      </button>
                    </div>
                  </div>
                ))}
              </div>

              <div className={styles.contBtn}>
                <Button
                  variant="primary"
                  className={`${styles.calBtn} ${
                    !Object.keys(booking.partner).length && `${styles.disabled}`
                  }`}
                  onClick={() => {
                    setVisible((prev) => prev + 1);
                  }}
                  disabled={!Object.keys(booking.partner).length}
                >
                  Continue
                </Button>
              </div>
            </div>
          ) : visible === 2 ? (
            //calendar and time picker
            <div className={styles.calendar}>
              <div className={styles.calSpace}>
                {!availableDayLoading && (
                  <Calendar
                    data={availableDay?.result || []}
                    dateSelected={dateSelected}
                    setDateSelected={setDateSelected}
                    onDateClick={onDateClick}
                  />
                )}
              </div>

              <DropdownMenu
                options={generateTimeSlots(availableDay?.result ?? [], 30, dateSelected, dayTime)}
                onSelect={handleSelect}
                placeholder="Pick Time"
                value={timeSelected}
              />

              <div className={styles.contBtn}>
                <Button
                  variant="primary"
                  className={`${styles.calBtn} ${
                    (!convertDateTimeArray(dateSelected)[0]?.start ||
                      !convertDateTimeArray(dateSelected)[0]?.end) &&
                    `${styles.disabled}`
                  }`}
                  onClick={() => {
                    setVisible((prev) => prev + 1);
                  }}
                  disabled={
                    !convertDateTimeArray(dateSelected)[0]?.start ||
                    !convertDateTimeArray(dateSelected)[0]?.end
                  }
                >
                  Continue
                </Button>
              </div>
            </div>
          ) : visible === 6 ? (
            //View partner profile
            <div className={styles.extend}>
              <h4>Partner profile</h4>
              <div className={styles.extendBox}>
                {viewProfile?.profilePictureUrl ? (
                  <img
                    className={styles.avatar}
                    src={viewProfile?.profilePictureUrl}
                    alt="avatar"
                  />
                ) : (
                  <img className={styles.avatar} src={user} alt="avatar" />
                )}
                <div>
                  <h3>
                    {viewProfile?.firstName} {viewProfile?.lastName}
                  </h3>
                  <div className={styles.funcs}>
                    {/* <p>{viewProfile?.rating}</p>
                    <p>{viewProfile?.sessions} sessions</p> */}
                    {viewProfile?.languagesTaught?.map((lang: langTaught, i: number) => (
                      <div key={i} className={styles.langTeach}>
                        <p>{lang?.language}</p>
                        <span>{lang.proficiency}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div>
                <p className={styles.surm}>Summary</p>
                <p>{viewProfile?.about}</p>
              </div>
            </div>
          ) : visible === 3 ? (
            <div className={styles.comtools}>
              <h4>Select Session Room</h4>
              <div
                className={
                  booking.comtools === "meet" ? styles.comtoolselected : styles.comtoolsBox
                }
                onClick={() => setBooking((prev) => ({ ...prev, comtools: "meet" }))}
              >
                <Icon name={"meet"} height={30} width={30} />
                <p>Google meet</p>
              </div>
              <div
                className={
                  booking.comtools === "teams" ? styles.comtoolselected : styles.comtoolsBox
                }
                onClick={() => setBooking((prev) => ({ ...prev, comtools: "teams" }))}
              >
                <Icon name={"teams"} height={30} width={30} />
                <p>teams</p>
              </div>
              <div
                className={
                  booking.comtools === "zoom" ? styles.comtoolselected : styles.comtoolsBox
                }
                onClick={() => setBooking((prev) => ({ ...prev, comtools: "zoom" }))}
              >
                <Icon name={"zoom"} height={30} width={30} />
                <p>Zoom</p>
              </div>

              <div className={styles.contBtn}>
                <Button
                  variant="primary"
                  className={`${styles.calBtn} ${!booking.comtools && `${styles.disabled}`}`}
                  onClick={() => {
                    setVisible((prev) => prev + 1);
                  }}
                  disabled={!booking.comtools}
                >
                  Continue
                </Button>
              </div>
            </div>
          ) : visible === 4 ? (
            <div>
              <h4>Confirm Booking</h4>
              <div className={styles.confirm}>
                <div className={styles.langType}>
                  <h4>Language Partner Sessions</h4>
                  <p>30minutes session</p>
                </div>

                <div className={styles.avsect}>
                  {booking?.partner?.profilePictureUrl ? (
                    <img
                      src={booking?.partner?.profilePictureUrl}
                      className={styles.avatar}
                      alt="avatar"
                    />
                  ) : (
                    <img alt="avatar" className={styles.avatar} src={user} />
                  )}
                  <p>
                    {booking?.partner?.firstName} {booking?.partner?.lastName}
                  </p>
                </div>

                <div className={styles.sessect}>
                  <div className={styles.sesHead}>
                    <p>Session time</p>
                    <button onClick={() => setVisible(2)}>
                      <Icon name="edit" width={20} height={20} />
                    </button>
                  </div>

                  <div className={styles.sesbody}>
                    <p className={styles.sesdate}>
                      {booking?.date instanceof Date
                        ? formatStringtoDate(booking.date.toLocaleDateString())
                        : ""}
                    </p>

                    <p className={styles.sestime}>{booking?.time}</p>
                  </div>
                </div>
              </div>
              <div className={styles.contBtn}>
                <Button
                  variant="primary"
                  className={`${styles.calBtn} ${
                    !booking.comtools || (isSubmitting && `${styles.disabled}`)
                  }`}
                  onClick={() => handleSubmit()}
                  disabled={!booking.comtools || isSubmitting}
                >
                  {isSubmitting ? "Processing" : " Confirm Booking"}
                </Button>
              </div>
            </div>
          ) : (
            <section>
              {/* <div className="space"></div> */}
              <NavLink to="/schedule">
                <ScheduleCard />
              </NavLink>
            </section>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
}
